import { useQuery } from "react-query";
import apiService from "../services/apiService";
import find from "lodash/find";
import { useLang } from "./LangHooks";
import { ClaimsData, ClaimType } from "../types/Claims";

export function useClaims(): ClaimsData {
  const lang = useLang();
  const { data } = useQuery(["claims", lang], async () =>
    apiService.loadClaims(lang)
  );
  return data as ClaimsData;
}

export function useClaimType(id: string): ClaimType | undefined {
  const claims = useClaims();
  return find(claims.types, { id });
}
